@if (assistant.pricingManaged$ | async) {
  <aside class="managed-banner" role="note">
    <span class="managed-banner__icon" aria-hidden="true"><mat-icon fontSet="material-icons-round">auto_awesome</mat-icon></span>
    <div class="managed-banner__text">
      <p class="managed-banner__title">{{ 'Prezzi gestiti con l\'assistente AI' | translate }}</p>
      <p class="managed-banner__body">{{ 'Questi prezzi sono stati impostati con l\'assistente: per tenerli coerenti si modificano solo da lì. Aggiunta, modifica ed eliminazione manuali sono disattivate.' | translate }}</p>
    </div>
    <div class="managed-banner__actions">
      <button mat-flat-button type="button" class="managed-banner__open" (click)="openAssistant()">
        {{ 'Apri l\'assistente' | translate }}
      </button>
      <button mat-button type="button" class="managed-banner__release" [disabled]="releasing" (click)="releaseToManual()">
        {{ 'Torna alla gestione manuale' | translate }}
      </button>
    </div>
  </aside>
}
